import React from "react";
import InputMask from "react-input-mask";
import InputField, { InputFieldProps } from "../InputField/InputField";

const DateField = React.forwardRef<
  HTMLInputElement,
  Omit<InputFieldProps, "InputComponent">
>(({ ...props }, ref) => {
  return (
    <InputField
      {...props}
      ref={ref}
      InputComponent={<InputMask mask="99.99.9999" />}
    />
  );
});

export default DateField;
